// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3D7TW","content":"LoadingAlert_content__bkkSC"};